import validateEmail from './lib/validateEmail.js';

class FFUpdateSubscription {
	DOM: {
		form: HTMLFormElement;
		submitButton: HTMLButtonElement;
		spinner: HTMLDivElement;
		email: HTMLInputElement;
		allInputs: NodeListOf<HTMLInputElement>;
	} = {} as any;
	state = {
		status: 'pending',
		valid: false,
		emailIsValid: false,
	};

	constructor() {
		const form = document.querySelector('.js-trainingForm');
		if (!form) return;
		this.DOM = {
			form: form as HTMLFormElement,
			submitButton: form.querySelector('.js-submitButton') as HTMLButtonElement,
			spinner: form.querySelector('.js-spinner') as HTMLDivElement,
			allInputs: form.querySelectorAll('input, select'),
			email: form.querySelector('.js-customerEmail') as HTMLInputElement,
		};
		this.events();
		this.render();
	}

	events() {
		this.DOM.form.addEventListener('submit', this.formSubmit.bind(this));
		this.DOM.form.addEventListener('keyup', this.formKeyUp.bind(this));
		for (let i = 0; i < this.DOM.allInputs.length; i++) {
			this.DOM.allInputs[i].addEventListener('input', this.globalInput.bind(this));
		}
	}

	formSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (!this.state.valid || this.state.status !== 'pending') return;
		this.state.status = 'working';
		this.render();
		const formData = new FormData(this.DOM.form);
		formData.append('action', 'training_submit');
		this.requestUpdate(formData);
	}

	requestUpdate(data: FormData) {
		grecaptcha.ready(() => {
			grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then((token: string) => {
				data.append('g-recaptcha-response', token);
				try {
					fetch(ajaxurl, {
						method: 'POST',
						body: data,
					}).then(this.formResponse.bind(this));
				} catch (error: any) {
					console.log(error);
					this.showErrorMessage(error);
					window.scrollTo({ top: window.scrollY + 300, behavior: 'smooth' });
					this.state.status = 'error';
					this.render();
				}
			});
		});
	}

	async formResponse(res: Response) {
		window.scrollTo({ top: window.scrollY + 300, behavior: 'smooth' });
		const data = await res.json();
		if (res.status === 200) {
			this.showSuccessMessage(data.message);
			this.state.status = 'success';
		} else {
			this.showErrorMessage(`Request could not be processed.`);
			this.state.status = 'error';
		}
		this.render();
	}

	formKeyUp() {
		this.validate();
		this.render();
	}

	globalInput() {
		this.validate();
		this.render();
	}

	validate() {
		let valid = true;
		for (const input of this.DOM.allInputs) {
			if (!input.required || input.value) continue;
			valid = false;
		}

		if (this.DOM.email.value) {
			if (!validateEmail(this.DOM.email.value)) {
				valid = false;
				this.state.emailIsValid = false;
			} else {
				this.state.emailIsValid = true;
			}
		}

		this.state.valid = valid;
		return valid;
	}

	render() {
		if (this.state.valid && this.state.status === 'pending') {
			this.DOM.submitButton.disabled = false;
		} else {
			this.DOM.submitButton.disabled = true;
		}
		if (this.state.status === 'working') {
			this.DOM.spinner.classList.remove('js-hide');
		} else {
			this.DOM.spinner.classList.add('js-hide');
		}
	}

	showSuccessMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'success');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Success!</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>${message}</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}

	showErrorMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'error');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Error</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>Uh oh. There was an issue with the form submission:</p>
      ${message ? `<pre>${message}</pre>` : ''}
      <p><a href="mailto:support@freeflysystems.com">Email support</a> for help.</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}
}
new FFUpdateSubscription();
